import React, { useState } from 'react';
import styles from './styles.module.css';
import checkbox from 'assets/checkbox.svg';
import checkboxChecked from 'assets/checkbox-checked.svg';
import closeCircle from 'assets/close-circle.svg';

const CustomMedication = ({ med, basket, deleteMed, updateBasket }) => {
  const [confirmDelete, setConfirmDelete] = useState(false);

  return (
    <div
      tabIndex="0"
      onKeyPress={(e) => (e.key === 'Enter' ? updateBasket(e, med.id, false) : null)}
      onClick={(e) => updateBasket(e, med.id, false)}
      className={styles.box_container}>
      <div className={`${styles.box_container__grid}`}>
        <div className={styles.image_container}>
          {confirmDelete ? (
            <img
              src={closeCircle}
              alt={`Delete ${med.name}`}
              onClick={(e) => {
                e.stopPropagation();
                deleteMed(med.id);
              }}
            />
          ) : (
            <img
              src={basket.includes(med.id) ? checkboxChecked : checkbox}
              alt={basket.includes(med.id) ? 'Remove from basket icon' : 'Add to basket icon'}
            />
          )}
        </div>
        <div>
          <h5 className={styles.med__title}>{med.name}</h5>
          <p className={styles.med__dosage}>{med.full_medication}</p>
          {confirmDelete ? (
            <p
              className={styles.med__edit}
              onClick={(e) => {
                e.stopPropagation();
                setConfirmDelete(false);
              }}>
              Cancel
            </p>
          ) : (
            <p
              className={styles.med__edit}
              onClick={(e) => {
                e.stopPropagation();
                setConfirmDelete(true);
              }}>
              Delete
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomMedication;
